import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alumni-landing',
  templateUrl: './alumni-landing.component.html',
  styleUrls: ['./alumni-landing.component.scss']
})
export class AlumniLandingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
